module.exports = __webpack_public_path__ + "static/img/Group.a7e2b37.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/NotFound/Group.png
// module id = cb7A
// module chunks = 1